import { render, staticRenderFns } from "./PendingMaintenancePlansForAssign.vue?vue&type=template&id=2d457a76"
import script from "./PendingMaintenancePlansForAssign.vue?vue&type=script&lang=ts"
export * from "./PendingMaintenancePlansForAssign.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports